import { render, staticRenderFns } from "./UserReferences.vue?vue&type=template&id=1b1b384e&scoped=true"
import script from "./UserReferences.vue?vue&type=script&lang=js"
export * from "./UserReferences.vue?vue&type=script&lang=js"
import style0 from "./UserReferences.vue?vue&type=style&index=0&id=1b1b384e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1b384e",
  null
  
)

export default component.exports